import { render } from "./EnquireLabsLogoIcon.vue?vue&type=template&id=9880372a"
import script from "./EnquireLabsLogoIcon.vue?vue&type=script&lang=js"
export * from "./EnquireLabsLogoIcon.vue?vue&type=script&lang=js"

import "./EnquireLabsLogoIcon.vue?vue&type=style&index=0&id=9880372a&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__